import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=61895a6d&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61895a6d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61895a6d')) {
      api.createRecord('61895a6d', component.options)
    } else {
      api.reload('61895a6d', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=61895a6d&scoped=true", function () {
      api.rerender('61895a6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/administratorAuthority/adminList/edit.vue"
export default component.exports